import styled, { css, SimpleInterpolation } from 'styled-components';

import Media from '../../../../assets/styles/media';
import THEME from '../../../../assets/styles/config';

export const CardCtn = styled.div`
  flex: 1 0 33%;
  max-width: 33%;
  padding: 10px 30px 10px 3px;
  position: relative;

  ${Media.Below.desktop`
    flex: 1 0 50%;
    max-width: 50%;
  `}
`;

interface CardProps {
  active?: boolean;
}

export const CardBody = styled.button<CardProps>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-color: ${THEME.colors.secondaryBackgroundColor};
  cursor: pointer;
  height: 128px;
  width: 100%;
  padding: 15px;
  box-shadow: ${THEME.etc.primaryBorderShadow};

  ${Media.Below.desktop`
    height: 100px;
    font-size: 15px;
  `}

  ${(props): SimpleInterpolation =>
    css &&
    props.active &&
    `
      outline: solid 1px #0082bd;
    `}

  > span {
    color: ${THEME.colors.primaryFontColor};
    overflow-wrap: break-word;
    word-break: break-word;
    text-align: start;
  }
`;
